<template>
    <div class="main-content-container container-fluid px-4">
        <div class="row">
            <div class="col">
                <div class="card card-small mb-4 mt-3" v-if="loading">
                    <div class="card-body">
                        <spinner-dot />
                    </div>
                </div>
                <template v-else>
                    <step-one v-if="step === 1" @input="handleStepOne" :request="request"
                        :originalRequest="originalRequest" />
                    <step-two v-else-if="step === 2" @input="handleStepTwo" :isCEE="isCEE" :request="request" />
                    <step-three v-else-if="step === 3" :model="request" @input="handleStepThree"></step-three>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import StepOne from "./steps/StepOne.vue";
import StepTwo from "./steps/StepTwo.vue";
import StepThree from "./steps/StepThree.vue";

export default {
    name: "employee",
    components: {
        StepOne,
        StepTwo,
        StepThree,
        SpinnerDot
    },
    mounted() {
        this.$services.employeeService
            .findByReference(this.$route.params.reference)
            .then(({ data }) => {
                this.request = data;
                this.originalRequest = JSON.parse(JSON.stringify(data));
                this.loading = false;
            });
    },
    computed: {
        user() {
            return this.$store.state.user.informations;
        },
    },
    data() {
        return {
            request: {},
            originalRequest: {},
            step: 1,
            loading: true,
            isCEE: false,
        };
    },
    methods: {
        handleStepOne(event) {
            if (event == "CEE") {
                this.isCEE = true;
            } else {
                this.isCEE = false;
            }
            this.step = 2;
        },
        handleStepTwo(answer) {
            if (!answer) {
                this.step = 1;
            } else {
                this.request = answer;
                this.step = 3;
            }
        },
        handleStepThree(answer) {
            if (!answer) {
                this.step = 2;
            } else {
                this.request.applicantID = this.user.reference;
                this.request.applicantFirstName = this.user.firstName;
                this.request.applicantLastName = this.user.lastName;
                this.request.status = "PENDING";
                this.request.typeOfContract = this.request.type;
                this.request.structureName = this.request.selectedStructure.name;
                this.request.structureID = this.request.selectedStructure.id;
                this.request.employeeReference = this.$route.params.reference;
                this.request.newDaysOfContract =
                    parseInt(this.originalRequest.daysOfContract) +
                    parseInt(this.request.daysOfContract);
                this.$services.contractRequestService
                    .createUnderEmployee(this.request)
                    .then(() => {
                        localStorage.removeItem("model");
                        this.$miniToastr.success(this.$t("days.off.request.success"));
                        this.$router.push("/employeeManagement");
                    })
                    .catch((e) => {
                        this.$miniToastr.error("Une erreur s'est produite.");
                    });
            }
        },
    },
};
</script>

<style></style>
